import { defineMessages } from 'react-intl';

const prefix = 'app.containers.TranslationSettings.MergeKeys.MergeKeysTable';

export const messages = defineMessages({
  columnActions: {
    id: `${prefix}.columnActions`,
    defaultMessage: 'Actions',
  },
  columnKey: {
    id: `${prefix}.columnKey`,
    defaultMessage: 'Merge key',
  },
  columnTranslatable: {
    id: `${prefix}.columnTranslatable`,
    defaultMessage: 'Translatable',
  },
  emptyState: {
    id: `${prefix}.emptyState`,
    defaultMessage: 'No merge keys added yet',
  },
  errorLoading: {
    id: `${prefix}.errorLoading`,
    defaultMessage:
      'There was an error loading merge keys. Try again later or contact support if the issue persists.',
  },
  noMatches: {
    id: `${prefix}.noMatches`,
    defaultMessage: 'No merge keys match "{query}"',
  },
  searchPlaceholder: {
    id: `${prefix}.searchPlaceholder`,
    defaultMessage: 'Search merge keys',
  },
});
